/*
 * @Author: zhang lin
 * @Date: 2022-04-08 13:09:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-09-06 09:52:00
 * @Description: file content
 */

import React, { forwardRef, useState, useEffect, useRef } from 'react';

import styles from './index.less';
import { Form, Button, Progress } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { getBasicInfo } from 'root/services/monitor';

import messages from './messages';
import {
  downloadInstlallLog,
  checkInstallApi,
  checkInstallStatusApi,
  getFileApi,
  updateFileApi,
  checkQuitApi,
  checkTaskStatusApi,
} from 'root/services/manager';
import { updatePlatformTimeApi } from 'root/services/netWork';
import { downloadFiles } from 'root/utils/utils';
import Modal from 'root/components/CommonModal';
import EditSysTime from 'root/components/EditSysTime';
import { useSelector } from 'react-redux';
import { reducerStates } from 'root/store/types';

import classnames from 'classnames';
import { message } from 'sup-ui';

interface FCFormProps extends FormComponentProps {
  stepAdd: () => void;
  webPort?: string;
  getInstallParams: () => {};
}

type Ref = FormComponentProps;
const { confirm } = Modal;
let loopTimer: any = null;

const checkInstall = forwardRef<FormComponentProps, FCFormProps>((props) => {
  const { stepAdd, webPort, getInstallParams } = props;
  const intl = useIntl();
  const [status, setStatus] = useState('');
  const [dataInfo, setDataInfo] = useState<any>({});
  const [editConfigVisible, setEditConfigVisible] = useState(false);
  const { selectedVersions, systemInfo } = useSelector((state: reducerStates) => state.fileConfig);

  const resutRef = useRef<HTMLDivElement>(null);
  const configRef = useRef<HTMLPreElement>(null);
  const EditSysTimeRef = useRef<Ref>();

  const statusText: { [props: string]: string } = {
    WAITING: intl.formatMessage(messages.waiting),
    NOT_CHECK: intl.formatMessage(messages.checking),
    PASS: intl.formatMessage(messages.pass),
    UN_PASS: intl.formatMessage(messages.unPass),
    OVERTIME: intl.formatMessage(messages.overtime),
  };
  const [failedCont, setFailedCont] = useState(0);
  const failedContStyle = classnames(styles.failedCont, {
    [styles.red]: failedCont > 0,
  });
  const [fileContent, setFileContent] = useState('');
  const [pathList, setPathList] = useState<string[]>([]);
  const [currentItem, setCurrentItem] = useState<{ [key: string]: string }>({});
  const [spinning, setSpinning] = useState(false);
  const [visibleSysTime, setVisibleSysTime] = useState(false);
  const [formList, setFormList] = useState([0]); // 多个ntp服务器
  const [sysTimeData, setSysTimeData] = useState({}); // 修改系统时间传默认对象

  useEffect(() => {
    getData();
    getSysTimeData();
    return () => {
      clearTimeout(loopTimer);
      loopTimer = null;
    };
  }, []);
  // 获取平台信息
  const getSysTimeData = () => {
    getBasicInfo().then((res: any) => {
      const { data } = res;
      const { auto, systemTime, timezone, ntpIP = [] } = data.timeInfo;

      setSysTimeData({
        timezone,
        isAuto: auto ? 1 : 0,
        systemTime: systemTime,
        ntpIP,
      });
      if (ntpIP?.length) setFormList(ntpIP.map((item: any, index: number) => index));
    });
  };

  // 获取检测数据
  const getData = () => {
    const installParams = getInstallParams();

    setStatus('checking');
    const params = {
      type: 'INSTALL',
      port: webPort,
      packages: [...Object.values({ ...selectedVersions }), systemInfo.archiveId],
      ...installParams,
    };

    checkTaskStatusApi().then((res) => {
      // 如果当前存在检测任务 直接获取任务状态
      if (res.data) {
        checkInstallStatus();
        return;
      }
      // 发起检测任务;
      checkInstallApi(params).then(() => {
        checkInstallStatus();
      });
    });
  };
  // 轮询获取状态
  const loopGetData = () => {
    clearTimeout(loopTimer);
    loopTimer = setTimeout(() => {
      checkInstallStatus();
    }, 1000 * 5);
  };

  const checkInstallStatus = () => {
    checkInstallStatusApi().then((res) => {
      const { data = {} } = res;
      const { result, errorDetails } = data;
      setDataInfo(data);

      // 检测中:设置失败条数
      setFailedCont(errorDetails.length);

      // 检测结束，关闭定时器
      if (result) {
        setStatus(result);
        clearTimeout(loopTimer);
        if (result === 'SUCCESS') {
          setTimeout(() => {
            stepAdd();
          }, 2000);
        }
        // 让检测结果显示滚动到视口
        if (resutRef?.current) {
          resutRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
        return;
      }
      loopGetData();
    });
  };

  // 下载错误问题日志
  const downloadLog = () => {
    downloadInstlallLog().then((res: any) => {
      const { data, headers } = res;
      const fileName = headers['content-disposition']?.split('filename=')[1];
      if (!fileName) return message.error(intl.formatMessage(messages.logNull));
      downloadFiles(data, fileName);
    });
  };

  // 退出安装
  const exitInstall = () => {
    checkQuitApi();
    window.isBeforeunloadTip = false;
    window.hashHistory.push('/instances');
  };

  // 点击继续安装
  const continueInstall = () => {
    confirm({
      content: intl.formatMessage(messages.continueInstallTip),
      onOk: () => {
        stepAdd();
      },
    });
  };

  // 在线编辑弹框
  const editConfig = (data: { ip: string; editPath: string; syncTime: boolean }) => {
    const { syncTime } = data;
    if (syncTime) {
      setVisibleSysTime(true);
      return;
    }
    getFile(data);
  };

  // 关闭在线编辑
  const closeEditModal = () => {
    setEditConfigVisible(false);
    setTimeout(() => {
      setFileContent('');
      setPathList([]);
      setCurrentItem({});
    }, 100);
  };

  // 关闭系统时间设置
  const handSysTimeCancel = () => {
    setVisibleSysTime(false);
  };
  // 根据文件路径获取内容
  const getFile = (data: { ip: string; editPath: string }) => {
    const { ip, editPath } = data;
    const params = {
      path: editPath,
      ip,
    };

    getFileApi(params).then((res) => {
      const {
        data: { content = '', paths, file },
      } = res;
      setEditConfigVisible(true);
      setCurrentItem(data);

      // file 为true，代表本级就是文件 为false 代表是目录
      if (file) {
        setFileContent(content);
        return;
      }
      setPathList(paths);
    });
  };

  // 修改系统时间
  const handSysTimeSubmit = () => {
    EditSysTimeRef?.current?.form.validateFields((err: any, values: any) => {
      if (err) return;
      const { isAuto, timezone, ntp } = values;
      const tempNtp = ntp?.filter((item: string) => item);
      const params = {
        timezone,
        isAuto,
        value: isAuto ? tempNtp : moment(values.date).tz(timezone).valueOf(),
      };
      setSpinning(true);
      setVisibleSysTime(false);
      updatePlatformTimeApi(params)
        .then(() => {
          message.success(intl.formatMessage(messages.success));
          setVisibleSysTime(false);
        })
        .finally(() => {
          setSpinning(false);
        });
    });
  };

  // 检查中UI
  const renderChecking = () => {
    return (
      <div className={styles.checkInstall}>
        <div className={styles.title}>
          <p className={styles.top}>
            <div>
              <span>{intl.formatMessage(messages.title)}</span>
            </div>

            <span>{`${dataInfo.percent || 0}%`}</span>
          </p>
          <div className={styles.subTitle}>
            <span> {intl.formatMessage(messages.tip)}</span>
            <div className={styles.checkFailed}>
              {intl.formatMessage(messages.altogether)}
              <span className={failedContStyle}>{failedCont}</span>
              {intl.formatMessage(messages.checkFailed)}
            </div>
          </div>
          <Progress percent={Number(dataInfo.percent)} showInfo={false} strokeColor="#00FFC9 " strokeWidth={6} />
        </div>

        <div className={styles.info}>
          <ul>
            {dataInfo?.checkResultItems?.map((item: any, index: number) => {
              const { description, status, failStrategy } = item;
              return (
                <li className={styles.item} key={index}>
                  <span className={styles.description}>{description}</span>
                  <span className={`${styles[status]} ${styles[failStrategy]}`}>
                    {failStrategy === 'CONFIRM' ? intl.formatMessage(messages.risk) : statusText[status]}
                  </span>
                </li>
              );
            })}
          </ul>
          {dataInfo.result && (
            <div className={styles[dataInfo.result]} ref={resutRef}>
              {intl.formatMessage(messages.result)}:
              {dataInfo.result === 'SUCCESS' ? intl.formatMessage(messages.pass) : intl.formatMessage(messages.unPass)}
            </div>
          )}
        </div>
        <div className={styles.btn}>
          <Button type="primary" onClick={exitInstall}>
            {intl.formatMessage(messages.exitInstall)}
          </Button>
        </div>
      </div>
    );
  };

  // 渲染结果项
  const renderItem = (data: any[]) => {
    return data?.map((item: any, index: number) => {
      const { error, cause, suggestion, editPath, syncTime, ip } = item;

      return (
        <li key={index} style={{ marginTop: 10 }}>
          <div className={styles.resultItem}>
            {index + 1} {error}
            {ip ? <span> （{ip}）</span> : null}
          </div>
          <p>
            {intl.formatMessage(messages.cause)}：{cause}
          </p>

          <p>
            {intl.formatMessage(messages.suggestion)}：{suggestion}
            {(editPath || syncTime) && (
              <span
                className={styles.editConfig}
                onClick={() => {
                  editConfig(item);
                }}
              >
                {intl.formatMessage(messages.editConfig)}
              </span>
            )}
          </p>
        </li>
      );
    });
  };

  // 渲染整体检查结果
  const renderCheckResult = () => {
    return (
      <div className={styles.checkInstall}>
        <div className={`${styles.title} ${styles.resultPanelTitle}`}>
          <p className={styles.top}>
            <div>
              <span>
                {intl.formatMessage(dataInfo?.errorDetails?.length ? messages.noPassTitle : messages.warnPassTitle)}
              </span>
            </div>
          </p>
          <div className={styles.subTitle}>
            <div className={styles.checkFailed}>
              {intl.formatMessage(messages.altogether)}
              {status === 'FAILED' ? (
                <>
                  <span className={failedContStyle}>{failedCont}</span>
                  {intl.formatMessage(messages.checkFailed)}
                </>
              ) : (
                <>
                  <span className={failedContStyle}>{dataInfo?.warnDetails?.length}</span>
                  {intl.formatMessage(messages.checkWawarn)}
                </>
              )}
            </div>
          </div>
        </div>

        <div className={`${styles.info} ${styles.resultContainer}`}>
          <div>
            {dataInfo?.errorDetails?.length ? (
              <h3 className={styles.resultWarningTitle}> {intl.formatMessage(messages.errorItemTitle)}</h3>
            ) : null}

            <ul>{renderItem(dataInfo.errorDetails)}</ul>
            {dataInfo?.warnDetails?.length ? (
              <>
                <h3 className={styles.resultTitle}> {intl.formatMessage(messages.warnItemTitle)}</h3>
                <ul>
                  <ul>{renderItem(dataInfo.warnDetails)}</ul>
                </ul>
              </>
            ) : null}
            {/* TODO  确定关键信息暂时没有 */}
            {/* <h3 className={styles.resultTitle}> {intl.formatMessage(messages.confirmKeyInfo)}</h3>
            <ul>
              {dataInfo?.warnDetails?.map((item: string) => {
                return (
                  <li key={item}>
                    <div className={styles.resultItem}>{item}</div>
                  </li>
                );
              })}
            </ul> */}
          </div>
        </div>
        <div className={styles.resultBtn}>
          <Button type="primary" onClick={downloadLog} className={styles.downloadBtn}>
            {intl.formatMessage(messages.download)}
          </Button>

          <div>
            <Button type="primary" onClick={exitInstall}>
              {intl.formatMessage(messages.exitInstall)}
            </Button>
            <Button type="primary" onClick={getData}>
              {intl.formatMessage(messages.retest)}
            </Button>
            {status === 'CONFIRM' && (
              <Button type="primary" onClick={continueInstall} className={styles.continueBtn}>
                {intl.formatMessage(messages.continueInstall)}
              </Button>
            )}
          </div>
        </div>
        <Modal
          title={intl.formatMessage(messages.editConfig)}
          visible={editConfigVisible}
          height="auto"
          onOk={() => {
            if (!fileContent) return closeEditModal();
            const { editPath, ip } = currentItem;
            const params = {
              path: editPath,
              ip,
              content: configRef.current?.innerText,
            };
            updateFileApi(params).then((res) => {
              const {
                data: { cause = '', success },
              } = res;
              if (success) {
                message.success(intl.formatMessage(messages.editSuccess));
                closeEditModal();
                return;
              }
              message.error(cause);
            });
          }}
          onCancel={closeEditModal}
        >
          <div>
            {fileContent ? (
              <pre ref={configRef} contentEditable="true" style={{ width: '100%' }}>
                {fileContent}
              </pre>
            ) : (
              <>
                <h4 className={styles.selectFileTitle}>{intl.formatMessage(messages.selectFile)}</h4>
                <ul>
                  {pathList?.map((item: string) => {
                    return (
                      <li
                        key={item}
                        className={styles.fileList}
                        onClick={() => {
                          getFile({ ip: currentItem.ip, editPath: item });
                        }}
                      >
                        {item}
                      </li>
                    );
                  })}
                </ul>
              </>
            )}
          </div>
        </Modal>
      </div>
    );
  };
  return (
    <div>
      {['FAILED', 'CONFIRM'].includes(status) ? renderCheckResult() : renderChecking()}

      <EditSysTime
        wrappedComponentRef={EditSysTimeRef}
        visible={visibleSysTime}
        onCancel={handSysTimeCancel}
        onOk={handSysTimeSubmit}
        record={sysTimeData}
        setFormList={setFormList}
        formList={formList}
        spinning={spinning}
      />
    </div>
  );
});
export default Form.create()(checkInstall);
